<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" epub:type="acknowledgments" id="_idContainer007">
<h1 class="Front-Title" id="_idParaDest-1"><a id="_idTextAnchor000"></a>Acknowledgments</h1>
<p class="Normal">Michelle Branson and the <em class="Emphasis _idGenCharOverride-1">entire</em> Gibbs Smith Team for your vote of confidence . . . again!</p>
<p class="Normal">Martha Hopkins of Terrace Partners, my agent, for your dedication, guidance, and patience. You keep me focused.</p>
<p class="Normal">Kathleen, Jeanne, Linda, Dede, Lisa, and Lily for that push across the finish line that I so desperately needed! Thank you for your friendship, support, and encouragement.</p>
<p class="Normal">The Augusta Gourmet Club, for being my forever champions!</p>
<p class="Normal">All my neighbors, friends, and family who served themselves up as my taste-testers.</p>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer008">
<img alt="Photo of small jars of marmalade." class="_idGenObjectAttribute-3" src="image/Brunch-Meyer_Marmalade-53.jpg"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Lets-Brunch-Interiors_D-2.vue?5c8ad55e